import { config } from "src/config";
import Http from "./api.service";


const HistroyService = () => {
    const api = Http(false, config().baseBackendUrl).instance;

    const getData = async (emailId: string, ctvQuarter: string) => {
        console.log('history service call', emailId + '' + ctvQuarter);
        return await api.get(`/history/${emailId}/${ctvQuarter}`)
            .then((response) => {
                return response.data;
            });
    }
    const getCtvQuarter = async () => {
        return await api.get(`/ctvquarters/`)
            .then((response) => {
                return response.data;
            });
    }



    api.interceptors.request.use((config) => {
        config.headers['Authorization'] = `Bearer ${sessionStorage.getItem('eva_token')}`;
        config.headers['Session'] = sessionStorage.getItem('eva_session');
        return config;
    });

    return { getData, getCtvQuarter }
}

export default HistroyService;